export const getEntriesByIds = <T extends Record<string, any>, K extends keyof T>(
  ids: K[],
  entries: T
): Pick<T, K> => {
  const result = {} as Pick<T, K>;
  for (const id of ids) {
    if (entries[id] !== undefined) {
      result[id] = entries[id];
    }
  }
  return result;
};
